function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 8V6h18v2H3zm0 5h18v-2H3v2zm0 5h18v-2H3v2z",
  fill: "#666"
})));